import styled from "styled-components";
import { zeeguuOrange } from "../components/colors";

const AddRemoveButton = styled.button`
  box-shadow: none;
  all: unset;
  margin: 0;
  color: ${zeeguuOrange};
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;
  padding-right: 40px;
`;

export { AddRemoveButton };
